<!--
component: WardButtonPad
author: Ken Nakamura
description: 区ボタンパネル
-->
<template>
  <section class="key-pad ward-button-pad">
    <v-container fluid>
      <v-row>
        <v-col v-for="(ward,index) in wards" :key="index" cols=4>
          <v-btn color="#c6e9ef" x-large width=100%
            class="text-h6 py-1" style="margin:-8px;"
            @click="selectWard(ward)"
            v-show="ntVisible || ward.code>14100"
            :disabled="ward.nendo>nendo">
            {{ ward.name }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import constants from '../common/constants'

export default {
  data: () => ({
    wards: constants.Wards
  }),
  props: {
    ntVisible: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {

  },
  computed: {
    nendo () {
      return this.$store.state.searchNendo ? this.$store.state.searchNendo.year : 0;
    }
  },
  methods: {
    /**
     * 区タンが押された時の処理
     * @param {Object} ward 選択された区オブジェクト
     */
    selectWard (ward) {
        this.$emit('selectWard', ward);
    },
  }
}
</script>

<style lang="scss" scoped>
.ward-button-pad {
    background-color: #b6d9df;
    user-select: none;
    width: 100%;
    height: 100%;
    padding: 8px 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2),
    0 25px 50px 0 rgba(0, 0, 0, 0.1);
}

</style>